jQuery(document).ready(function () {
    initDnTextareaTinyMce();
});


// Editor ist HugeRTE (MIT-Fork von TinyMCE 6); content_style übernimmt Schrift und Abstände des früheren
// TinyMCE-4-Skins „dn“, min_height die bisherige Mindesthöhe (Schreibfläche 72 px plus Werkzeugleiste);
// den seitlichen Innenabstand setzt das Autoresize-Plugin selbst (autoresize_overflow_padding)
var initDnTextareaTinyMce = function () {

    if (typeof hugerte === 'undefined') {
        return;
    }

    hugerte.remove();
    hugerte.init({
        selector:'.dnFormTextareaTinyMce-field',
        menubar:false,
        statusbar: false,
        plugins: ['code', 'link', 'autoresize'],
        toolbar: ['bold italic | cut copy paste | undo redo | link'],
        width: '100%',
        min_height: 123,
        autoresize_overflow_padding: 12,
        paste_as_text: true,
        invalid_elements: "pre",
        forced_root_block: "p",
        content_style: 'body{background-color:#fff;color:#4a4a4a;font-family:Verdana,Arial,Helvetica,sans-serif;font-size:16px;margin:0;padding-bottom:4px}' +
            'p{margin:8px 0;line-height:1.5}p:first-of-type{margin-top:0}p:last-of-type{margin-bottom:0}',
        init_instance_callback: function (editor) {
            editor.on('focus', function (e) {
                $(editor.contentAreaContainer).closest('.dnFormTextarea-container').addClass('dnFormTextarea-container-focus');
            });
            editor.on('blur', function (e) {
                $(editor.contentAreaContainer).closest('.dnFormTextarea-container').removeClass('dnFormTextarea-container-focus');
            });
        }
    });
};

$(document).on('loaded.form.ajax', function (e) {
    initDnTextareaTinyMce();
});
